export const gdprData=[
    {
        key: "clientId",
        fieldName: "Client ID",
        type: "number",
        required: true,
        tooltip: true,
    },
    {
        key: "userId",
        fieldName: "Candidate User IDs",
        type: "text",
        required: true,
        helperText: "For multiple candidates, please provide comma separated unique ids (maximum : 2)",
        tooltip: false
    }
]


export const bulkGdprData = [
    {
        key: "clientId",
        fieldName: "Client ID",
        type: "number",
        required: true,
        tooltip: false
    },
    {
        key: "userId",
        fieldName: "Candidate User IDs",
        type: "file",
        required: true,
        multiple: false,
        accept: ".xls,.xlsx",
        helperText: "xls, xlsx supported (Maximum file size: 200 KB)",
        tooltip: true

    }
]

export const status = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
}




